<nav class="navbar d-block navbar-expand-lg navbar-dark pb-0 pt-1 smileOrchard-navbar bg-dark smileOrchard-navbar-light"
    id="smileOrchard-navbar">
    <div class="d-block w-100">
        <div class="container">
            <a class="navbar-brand" routerLink="/" aria-label="Home">
                <div *ngIf="isHomeDental" style="background-image: url({{videoCdnUrl}}images/OLogo.png);"></div>
                <div *ngIf="!isHomeDental" style="background-image: url({{videoCdnUrl}}images/Smile_Orchard_Logo.png);">
                </div>
            </a>
            <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#ftco-nav"
                aria-expanded="false" aria-label="Menu" aria-controls="ftco-nav">
                <h4 class="fa fa-bars blackColor"></h4>
            </button>

            <!-- navbar-collapse -->
            <div class="collapse" id="ftco-nav">
                <div class="d-block w-100">
                    <ul role="list" class="navbar-nav justify-content-end align-items-center" *ngIf="isHome">
                        <li class="nav-item nav-btn">
                            <a href="tel:01179 567603" aria-label="01179 567603"
                                class="btn btn-primary nav-btn-no-fill m-1 text-black rounded py-1 px-5">
                                <span class="text-white">01179 567603</span>
                            </a>
                        </li>
                        <li class="nav-item nav-btn">
                            <a routerLink="/Emergency Contact Us" aria-label="Emergencies"
                                class="btn btn-primary m-1 text-white rounded py-1 px-5">
                                <span class="text-white">Emergencies</span>
                            </a>
                        </li>
                        <li class="nav-item nav-btn">
                            <a (click)="BookAnAppointment()" aria-label="Book Online"
                                class="btn btn-primary m-1 text-white rounded py-1 px-5">
                                <span class="text-white">Book Online</span>
                            </a>
                        </li>
                    </ul>
                    <ul class="nav nav-pills ml-auto align-items-center justify-content-between" id="pills-tab"
                        role="tablist">
                        <li role="tab" class="nav-item">
                            <a class="nav-link" id="pills-about-tab" data-toggle="pill"
                                [routerLink]="['/About Us',{Type:'AboutUs'}]" role="tab" aria-controls="pills-about"
                                aria-selected="false" aria-label="About"
                                style="text-decoration: none !important;text-decoration-color: black;">About</a>
                        </li>
                        <li role="tab" class="nav-item">
                            <a class="nav-link" id="pills-techonology-tab" data-toggle="pill" routerLink="/Technology"
                                role="tab" aria-controls="pills-techonology" aria-label="Lasers"
                                aria-selected="false">Lasers</a>
                        </li>
                        <li role="tab" class="nav-item">
                            <a class="nav-link" id="pills-treatment-tab" data-toggle="pill"
                                [routerLink]="['/Treatments']" role="tab" aria-controls="pills-treatment"
                                aria-label="Services" aria-selected="false">Services</a>
                        </li>
                        <li role="tab" class="nav-item">
                            <a class="nav-link" id="pills-fees-tab" data-toggle="pill" routerLink="/TreatmentGallery" role="tab"
                                aaria-label="Fees" aria-controls="pills-fees" aria-selected="false">Treatment Gallery</a>
                        </li>
                        <li role="tab" class="nav-item">
                            <a class="nav-link" id="pills-membership-tab" data-toggle="pill" routerLink="/Membership"
                                aria-label="Membership" role="tab" aria-controls="pills-membership"
                                aria-selected="false">Membership</a>
                        </li>
                        <li role="tab" class="nav-item">
                            <a class="nav-link" id="pills-fees-tab" data-toggle="pill" routerLink="/Fees" role="tab"
                                aria-label="Fees" aria-controls="pills-fees" aria-selected="false">Fees</a>
                        </li>

                        <li role="tab" class="nav-item">
                            <a class="nav-link" id="pills-referals-tab" data-toggle="pill" routerLink="/Referrals"
                                aria-label="Referrals" role="tab" aria-controls="pills-referals"
                                aria-selected="false">Referrals</a>
                        </li>
                        <li role="tab" class="nav-item">
                            <a class="nav-link" id="pills-dentist-tab" data-toggle="pill" routerLink="/Dentists Lounge"
                                aria-label="Dentist Lounge" role="tab" aria-controls="pills-dentist"
                                aria-selected="false">Dentist's Lounge</a>
                        </li>
                       
                        <li role="tab" class="nav-item">
                            <a class="nav-link" id="pills-faq-tab" data-toggle="pill"
                                [routerLink]="['Faqs',{Type:'TreatmentFAQs',FAQName:'Dental Implant'}]" role="tab"
                                aria-label="FAQ" aria-controls="pills-faq" aria-selected="false">FAQ's</a>
                        </li>
                        
                        <li role="tab" class="nav-item">
                            <a class="nav-link" id="pills-contact-tab" data-toggle="pill" routerLink="/Contact Us"
                                role="tab" aria-controls="pills-contact" aria-selected="false"
                                aria-label="Contact Us">Contact Us</a>
                        </li>
                        <li role="tab" class="nav-item">
                            <a class="nav-link" id="pills-fees-tab" data-toggle="pill" routerLink="/blogs" role="tab"
                                aria-label="Fees" aria-controls="pills-fees" aria-selected="false">Blogs</a>
                        </li>
                        <li role="tab" class="nav-item">
                            <a class="nav-link" id="pills-sign-in-tab" data-toggle="pill" routerLink="/Log In"
                                *ngIf="!isLoggedIn" role="tab" aria-controls="pills-sign-in" aria-label="Log In"
                                aria-selected="false">Log In</a>
                            <div class="btn-group " *ngIf="isLoggedIn">
                                <ngx-avatar name={{UserName}} size="45"></ngx-avatar>
                                <p type="button"
                                    class="dropdown-toggle profile-dropdown-toggle dropdown-toggle-split mb-auto mt-auto"
                                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    <span class="sr-only">Toggle Dropdown</span>
                                </p>
                                <div class="dropdown-menu dropdown-menu-right">
                                    <div class="d-flex align-items-center dropdown-item cursor"
                                        (click)="viewMyProfile()">
                                        <img loading="lazy" src="{{videoCdnUrl}}images/profile.svg" height="25"
                                            width="25" alt="profile">
                                        <p class="ml-2 mb-0">Profile</p>
                                    </div>
                                    <div class="d-flex align-items-center dropdown-item cursor" *ngIf="isPractice && !isDentist"
                                        (click)="viewOurDentists()">
                                        <img loading="lazy" src="{{videoCdnUrl}}images/JobApply.svg"
                                            alt="My Referrals" height="25" width="25">
                                        <p class="ml-2 mb-0">Our Clinicians</p>
                                    </div>
                                    <div class="d-flex align-items-center dropdown-item cursor" *ngIf="isDentist || isPractice"
                                        (click)="viewMyReferrals()">
                                        <img loading="lazy" src="{{videoCdnUrl}}images/referPatient.svg"
                                            alt="My Referrals" height="25" width="25">
                                        <p class="ml-2 mb-0" *ngIf="isDentist">My Referrals</p>
                                        <p class="ml-2 mb-0" *ngIf="isPractice">Our Referrals</p>
                                    </div>
                                    
                                    <div class="d-flex align-items-center dropdown-item cursor" (click)="logOut()">
                                        <img loading="lazy" src="{{videoCdnUrl}}images/logout.svg" alt="logOut"
                                            height="25" width="25">
                                        <p class="ml-2 mb-0">Logout</p>
                                    </div>
                                    
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>


        <div class="carouselContainer" *ngIf="isTreatment">
            <div class="d-none d-md-block container">
                <div class="d-flex justify-content-center pt-1 pb-0 align-items-start treatmentOptions">
                    <div class="item text-center mx-2 p-0" [ngClass]="{'clicked': clicked, '': !clicked}"
                        *ngFor="let items of treatmentCarousel;let i = index">
                        <!--added mx-2 p-0 -->
                        <div class="dropdown-section">
                            <div>
                                <a *ngIf="items.id!==7"
                                    [routerLink]="['/Treatments',{TreatmentType:items.treatmentSectionTitle}]"
                                    style="text-decoration: none !important;" aria-label="Treatment">
                                    <img loading="lazy" src={{items.treatmentImage}} class="m-auto"
                                        style="width: 28px;height: 28px;" alt="treatmentImage">
                                    <p class="text-center treatmentTitle pt-0 pb-0 mb-0"
                                        style="color:white;word-break: normal;">{{items.treatmentTitle}}</p>
                                </a>
                                <a *ngIf="items.id===7" [routerLink]="['/Conscious Sedation']"
                                    style="text-decoration: none !important;" aria-label="Treatment">
                                    <img loading="lazy" src={{items.treatmentImage}} class="m-auto"
                                        style="width: 28px;height: 28px;" alt="treatmentImage">
                                    <p class="text-center treatmentTitle pt-0 pb-0 mb-0"
                                        style="color:white;word-break: normal;">{{items.treatmentTitle}}</p>
                                </a>
                                <img loading="lazy" src="{{videoCdnUrl}}images/dropdownWhite.svg"
                                    class="w-100 dropdown-toggle dropdown-top" id="dropdownMenu-{{items.id}}"
                                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                                    [ngClass]="{'d-none': items.id===7}" height="13" width="15" alt="treatmentImage">

                                <div class="dropdown-menu" attr.aria-labelledby="dropdownMenu-{{items.id}}">
                                    <div *ngIf="items.id===1 ||items.id==='1'">
                                        <div class="item text-center w-100"
                                            *ngFor="let items of GeneralTreatments;let i = index">
                                            <a [routerLink]="['Treatment',{TreatmentType:'General',TreatmentID:items.id,Treatment:items.treatmentTitle}]"
                                                class="w-100" style="text-decoration: none !important;"
                                                aria-label="Treatment">
                                                <img loading="lazy" src={{items.treatmentImage}} class="m-auto"
                                                    style="width: 28px;height: 28px;" alt="treatmentImage">
                                                <p class="text-center treatmentTitle pt-0 pb-0 mb-1">
                                                    {{items.treatmentTitle}}
                                                </p>
                                            </a>
                                        </div>
                                    </div>
                                    <div *ngIf="items.id===2||items.id==='2'">
                                        <div class="item text-center w-100"
                                            *ngFor="let items of PreventativeDentistry;let i = index">
                                            <a [routerLink]="['Treatment',{TreatmentType:'Preventative',TreatmentID:items.id,Treatment:items.treatmentTitle}]"
                                                class="w-100" style="text-decoration: none !important;"
                                                aria-label="Treatment">
                                                <img loading="lazy" src={{items.treatmentImage}} class="m-auto"
                                                    style="width: 28px;height: 28px;" alt="treatmentImage">
                                                <p class="text-center treatmentTitle pt-0 pb-0 mb-1">
                                                    {{items.treatmentTitle}}
                                                </p>
                                            </a>
                                        </div>
                                    </div>
                                    <div *ngIf="items.id===3||items.id==='3'">
                                        <div class="item text-center w-100"
                                            *ngFor="let items of CosmeticDentistry;let i = index">
                                            <a class="w-100" style="text-decoration: none !important;"
                                                [routerLink]="['Treatment',{TreatmentType:'Cosmetic',TreatmentID:items.id,Treatment:items.treatmentTitle}]"
                                                aria-label="Treatment">
                                                <img loading="lazy" src={{items.treatmentImage}} class="m-auto"
                                                    style="width: 28px;height: 28px;" alt="treatmentImage">
                                                <p class="text-center treatmentTitle pt-0 pb-0 mb-1">
                                                    {{items.treatmentTitle}}
                                                </p>
                                            </a>
                                        </div>
                                    </div>
                                    <div *ngIf="items.id===4||items.id==='4'">
                                        <div class="item text-center w-100">
                                            <a class="w-100" style="text-decoration: none !important;"
                                                [routerLink]="['Dental Implant']" aria-label="Treatment">
                                                <img loading="lazy" src="{{videoCdnUrl}}images/dentist.svg"
                                                    alt="dentist" class="m-auto" style="width: 28px;height: 28px;">
                                                <p class="text-center treatmentTitle pt-0 pb-0">Dental Implants
                                                </p>
                                            </a>
                                        </div>
                                        <div class="item text-center w-100">
                                            <a class="w-100" style="text-decoration: none !important;"
                                                [routerLink]="['Bridges']" aria-label="Treatment">
                                                <img loading="lazy" src="{{videoCdnUrl}}images/tooth.svg" class="m-auto"
                                                    style="width: 28px;height: 28px;" alt="tooth">
                                                <p class="text-center treatmentTitle pt-0 pb-0">Bridges
                                                </p>
                                            </a>
                                        </div>
                                        <div class="item text-center w-100">
                                            <a class="w-100" style="text-decoration: none !important;"
                                                [routerLink]="['Dentures']" aria-label="Treatment">
                                                <img loading="lazy" src="{{videoCdnUrl}}images/teeth.svg" alt="teeth"
                                                    class="m-auto" style="width: 28px;height: 28px;">
                                                <p class="text-center treatmentTitle pt-0 pb-0">Dentures
                                                </p>
                                            </a>
                                        </div>
                                        <div class="item text-center w-100">
                                            <a class="w-100" style="text-decoration: none !important;"
                                                [routerLink]="['Denture Stabilisation']" aria-label="Treatment">
                                                <img loading="lazy" src="{{videoCdnUrl}}images/swollen.svg"
                                                    alt="swollen" class="m-auto" style="width: 28px;height: 28px;">
                                                <p class="text-center treatmentTitle pt-0 pb-0">Denture Stabilisation
                                                </p>
                                            </a>
                                        </div>
                                    </div>
                                    <div *ngIf="items.id===5||items.id==='5'">
                                        <div class="item text-center w-100">
                                            <a class="w-100" style="text-decoration: none !important;"
                                                [routerLink]="['Orthodontics']" aria-label="Treatment">
                                                <img loading="lazy" src="{{videoCdnUrl}}images/tooth.svg" alt="tooth"
                                                    class="m-auto" style="width: 28px;height: 28px;">
                                                <p class="text-center treatmentTitle pt-0 pb-0">Orthodontics
                                                </p>
                                            </a>
                                        </div>
                                        <div class="item text-center w-100">
                                            <a class="w-100" style="text-decoration: none !important;"
                                                [routerLink]="['Invisalign']" aria-label="Treatment">
                                                <img loading="lazy" src="{{videoCdnUrl}}images/teeth.svg" alt="teeth"
                                                    class="m-auto" style="width: 28px;height: 28px;">
                                                <p class="text-center treatmentTitle pt-0 pb-0">Invisalign
                                                </p>
                                            </a>
                                        </div>
                                        <div class="item text-center w-100">
                                            <a class="w-100" style="text-decoration: none !important;"
                                                [routerLink]="['Six Month Smiles']" aria-label="Treatment">
                                                <img loading="lazy" src="{{videoCdnUrl}}images/swollen.svg"
                                                    alt="swollen" class="m-auto" style="width: 28px;height: 28px;">
                                                <p class="text-center treatmentTitle pt-0 pb-0">Six Month Smiles
                                                </p>
                                            </a>
                                        </div>
                                    </div>
                                    <div *ngIf="items.id===6||items.id==='6'">
                                        <div class="item text-center  w-100">
                                            <a class="w-100" style="text-decoration: none !important;"
                                                [routerLink]="['Smile Design']" aria-label="Treatment">
                                                <img loading="lazy" src="{{videoCdnUrl}}images/dentist.svg"
                                                    alt="dentist" class="m-auto" style="width: 28px;height: 28px;">
                                                <p class="text-center treatmentTitle pt-0 pb-0 mb-1">Smile design
                                                </p>
                                            </a>
                                        </div>
                                        <div class="item text-center w-100">
                                            <a class="w-100" style="text-decoration: none !important;"
                                                [routerLink]="['Botox & Fillers']" aria-label="Treatment">
                                                <img loading="lazy" src="{{videoCdnUrl}}images/tooth.svg" alt="tooth"
                                                    class="m-auto" style="width: 28px;height: 28px;">
                                                <p class="text-center treatmentTitle pt-0 pb-0 mb-1">Facial Aesthetics
                                                </p>
                                            </a>
                                        </div>
                                        <div class="item text-center w-100">
                                            <a class="w-100" style="text-decoration: none !important;"
                                                [routerLink]="['Treatment',{TreatmentType:'BoldBeautiful',TreatmentID:4,Treatment:'Teeth Whitening'}]"
                                                aria-label="Treatment">
                                                <img loading="lazy" src="{{videoCdnUrl}}images/teeth.svg" alt="teeth"
                                                    class="m-auto" style="width: 28px;height: 28px;">
                                                <p class="text-center treatmentTitle pt-0 pb-0 mb-1">Teeth Whitening
                                                </p>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="item text-center mx-2 p-0" [ngClass]="{'clicked': clicked, '': !clicked}">
                        <div class="dropdown-section">
                            <a [routerLink]="['Dental Implant']" style="text-decoration: none !important;"
                                aria-label="Treatment">
                                <img loading="lazy" src="{{videoCdnUrl}}images/dental-implant-white.svg"
                                    alt="dental-implant-white" class="m-auto" style="width: 28px;height: 28px;">
                                <p class="text-center treatmentTitle pt-0 pb-0 mb-0"
                                    style="color:white;word-break: normal;">Dental Implants</p>
                            </a>
                            <img loading="lazy" src="{{videoCdnUrl}}images/dropdownWhite.svg" alt="dropdownWhite"
                                class="w-100 dropdown-toggle dropdown-top" id="dentalImplantDropdownMenu"
                                data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" height="13"
                                width="15">

                            <div class="dropdown-menu" attr.aria-labelledby="dentalImplantDropdownMenu">
                                <div class="item text-center w-100"
                                    *ngFor="let items of DentalImplantMenu;let i = index">
                                    <a [routerLink]="['Dental Implant',{TreatmentType:items.treatmentSectionTitle}]"
                                        class="w-100" style="text-decoration: none !important;" aria-label="Treatment">
                                        <img loading="lazy" src={{items.treatmentImage}} alt="treatmentImage"
                                            class="m-auto" style="width: 28px;height: 28px;">
                                        <p class="text-center treatmentTitle pt-0 pb-0 mb-1">{{items.treatmentTitle}}
                                        </p>
                                    </a>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div class="item text-center mx-2 p-0" [ngClass]="{'clicked': clicked, '': !clicked}">
                        <a [routerLink]="['Smile Design']" class="w-100" style="text-decoration: none !important;"
                            aria-label="Treatment">
                            <img loading="lazy" src="{{videoCdnUrl}}images/smileDesign-white.svg"
                                alt="smileDesign-white" class="m-auto" style="width: 28px;height: 28px;">
                            <p class="text-center treatmentTitle pt-0 pb-0 mb-1" style="color:white">Smile Design</p>
                        </a>
                    </div>
                </div>

            </div>

            <div class="d-sm-block d-md-none">
                <owl-carousel-o [options]="treatmentOptions"
                    class="container no-wrap justify-content-center pt-1 pb-0 align-items-start treatmentOptions">
                    <ng-template carouselSlide *ngFor="let items of treatmentCarousel;let i = index">
                        <div class="item text-center mx-2 p-0" [ngClass]="{'clicked': clicked, '': !clicked}">
                            <div class="dropdown-section">
                                <div>
                                    <a *ngIf="items.id!==7"
                                        [routerLink]="['Treatments',{TreatmentType:items.treatmentSectionTitle}]"
                                        style="text-decoration: none !important;" aria-label="Treatment">
                                        <img loading="lazy" src={{items.treatmentImage}} class="m-auto"
                                            alt="treatmentImage" style="width: 28px;height: 28px;">
                                        <p class="text-center treatmentTitle pt-0 pb-0 mb-0"
                                            style="color:white;word-break: normal;">{{items.treatmentTitle}}</p>
                                    </a>
                                    <a *ngIf="items.id===7"
                                        [routerLink]="['Treatment',{TreatmentType:'ConsciousSedation',TreatmentID:1}]"
                                        style="text-decoration: none !important;" aria-label="Treatment">
                                        <img loading="lazy" src={{items.treatmentImage}} class="m-auto"
                                            alt="treatmentImage" style="width: 28px;height: 28px;">
                                        <p class="text-center treatmentTitle pt-0 pb-0 mb-0"
                                            style="color:white;word-break: normal;">{{items.treatmentTitle}}</p>
                                    </a>
                                    <img loading="lazy" src="{{videoCdnUrl}}images/dropdownWhite.svg"
                                        alt="dropdownWhite" class="w-100 dropdown-toggle" id="dropdownMenu-{{items.id}}"
                                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                                        [ngClass]="{'d-none': items.id===7}" height="13" width="15">

                                    <div class="dropdown-menu" attr.aria-labelledby="dropdownMenu-{{items.id}}">
                                        <div *ngIf="items.id===1 ||items.id==='1'">
                                            <div class="item text-center w-100"
                                                *ngFor="let items of GeneralTreatments;let i = index">
                                                <a [routerLink]="['Treatment',{TreatmentType:'General',TreatmentID:items.id,Treatment:items.treatmentTitle}]"
                                                    class="w-100" style="text-decoration: none !important;"
                                                    aria-label="Treatment">
                                                    <img loading="lazy" src={{items.treatmentImage}} class="m-auto"
                                                        alt="treatmentImage" style="width: 28px;height: 28px;">
                                                    <p class="text-center treatmentTitle pt-0 pb-0 mb-1">
                                                        {{items.treatmentTitle}}
                                                    </p>
                                                </a>
                                            </div>
                                        </div>
                                        <div *ngIf="items.id===2||items.id==='2'">
                                            <div class="item text-center w-100"
                                                *ngFor="let items of PreventativeDentistry;let i = index">
                                                <a [routerLink]="['Treatment',{TreatmentType:'Preventative',TreatmentID:items.id,Treatment:items.treatmentTitle}]"
                                                    class="w-100" style="text-decoration: none !important;"
                                                    aria-label="Treatment">
                                                    <img loading="lazy" src={{items.treatmentImage}} class="m-auto"
                                                        alt="treatmentImage" style="width: 28px;height: 28px;">
                                                    <p class="text-center treatmentTitle pt-0 pb-0 mb-1">
                                                        {{items.treatmentTitle}}
                                                    </p>
                                                </a>
                                            </div>
                                        </div>
                                        <div *ngIf="items.id===3||items.id==='3'">
                                            <div class="item text-center w-100"
                                                *ngFor="let items of CosmeticDentistry;let i = index">
                                                <a class="w-100" style="text-decoration: none !important;"
                                                    [routerLink]="['Treatment',{TreatmentType:'Cosmetic',TreatmentID:items.id,Treatment:items.treatmentTitle}]"
                                                    aria-label="Treatment">
                                                    <img loading="lazy" src={{items.treatmentImage}} class="m-auto"
                                                        alt="treatmentImage" style="width: 28px;height: 28px;">
                                                    <p class="text-center treatmentTitle pt-0 pb-0 mb-1">
                                                        {{items.treatmentTitle}}
                                                    </p>
                                                </a>
                                            </div>
                                        </div>
                                        <div *ngIf="items.id===4||items.id==='4'">
                                            <div class="item text-center w-100">
                                                <a class="w-100" style="text-decoration: none !important;"
                                                    [routerLink]="['Dental Implant']" aria-label="Treatment">
                                                    <img loading="lazy" src="{{videoCdnUrl}}images/dentist.svg"
                                                        alt="dentist" class="m-auto" style="width: 28px;height: 28px;">
                                                    <p class="text-center treatmentTitle pt-0 pb-0">Dental Implants
                                                    </p>
                                                </a>
                                            </div>
                                            <div class="item text-center w-100"
                                                *ngFor="let items of MissingTeeth;let i = index">
                                                <a class="w-100" aria-label="Treatment"
                                                    style="text-decoration: none !important;"
                                                    [routerLink]="['Treatment',{TreatmentType:'MissingTeeth',TreatmentID:items.id,Treatment:items.treatmentTitle}]">
                                                    <img loading="lazy" src={{items.treatmentImage}} class="m-auto"
                                                        alt="treatmentImage" style="width: 28px;height: 28px;">
                                                    <p class="text-center treatmentTitle pt-0 pb-0 mb-1">
                                                        {{items.treatmentTitle}}
                                                    </p>
                                                </a>
                                            </div>
                                        </div>
                                        <div *ngIf="items.id===5||items.id==='5'">
                                            <div class="item text-center w-100"
                                                *ngFor="let items of Braces;let i = index">
                                                <a class="w-100" aria-label="Treatment"
                                                    style="text-decoration: none !important;"
                                                    [routerLink]="['Treatment',{TreatmentType:'Braces',TreatmentID:items.id,Treatment:items.treatmentTitle}]">
                                                    <img loading="lazy" src={{items.treatmentImage}} class="m-auto"
                                                        alt="treatmentImage" style="width: 28px;height: 28px;">
                                                    <p class="text-center treatmentTitle pt-0 pb-0 mb-1">
                                                        {{items.treatmentTitle}}
                                                    </p>
                                                </a>
                                            </div>
                                        </div>
                                        <div *ngIf="items.id===6||items.id==='6'">
                                            <div class="item text-center  w-100">
                                                <a class="w-100" aria-label="Treatment"
                                                    style="text-decoration: none !important;"
                                                    [routerLink]="['Smile Design']">
                                                    <img loading="lazy" src="{{videoCdnUrl}}images/dentist.svg"
                                                        class="m-auto" alt="dentist" style="width: 28px;height: 28px;">
                                                    <p class="text-center treatmentTitle pt-0 pb-0 mb-1">Smile design
                                                    </p>
                                                </a>
                                            </div>
                                            <div class="item text-center w-100">
                                                <a class="w-100" aria-label="Treatment"
                                                    style="text-decoration: none !important;"
                                                    [routerLink]="['Botox & Fillers']">
                                                    <img loading="lazy" src="{{videoCdnUrl}}images/tooth.svg"
                                                        class="m-auto" alt="tooth" style="width: 28px;height: 28px;">
                                                    <p class="text-center treatmentTitle pt-0 pb-0 mb-1">Facial
                                                        Aesthetics
                                                    </p>
                                                </a>
                                            </div>
                                            <div class="item text-center w-100">
                                                <a class="w-100" aria-label="Treatment"
                                                    style="text-decoration: none !important;"
                                                    [routerLink]="['Treatment',{TreatmentType:'BoldBeautiful',TreatmentID:items.id,Treatment:items.treatmentTitle}]">
                                                    <img loading="lazy" src="{{videoCdnUrl}}images/teeth.svg"
                                                        class="m-auto" alt="teeth" style="width: 28px;height: 28px;">
                                                    <p class="text-center treatmentTitle pt-0 pb-0 mb-1">Teeth Whitening
                                                    </p>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-template>

                    <ng-template carouselSlide>
                        <div class=" text-center mx-2 p-0" [ngClass]="{'clicked': clicked, '': !clicked}">
                            <div class="dropdown-section">
                                <a [routerLink]="['Dental Implant']" aria-label="Treatment"
                                    style="text-decoration: none !important;">
                                    <img loading="lazy" src="{{videoCdnUrl}}images/dental-implant-white.svg"
                                        class="m-auto" alt="dentalImplantDropdownMenu"
                                        style="width: 28px;height: 28px;">
                                    <p class="text-center treatmentTitle pt-0 pb-0 mb-0"
                                        style="color:white;word-break: normal;">Dental Implants</p>
                                </a>
                                <img loading="lazy" src="{{videoCdnUrl}}images/dropdownWhite.svg"
                                    class="w-100 dropdown-toggle" alt="dropdownWhite" id="dentalImplantDropdownMenu"
                                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" height="13"
                                    width="15">

                                <div class="dropdown-menu" attr.aria-labelledby="dentalImplantDropdownMenu">
                                    <div class="item text-center w-100"
                                        *ngFor="let items of DentalImplantMenu;let i = index">
                                        <a [routerLink]="['Dental Implant',{TreatmentType:items.treatmentSectionTitle}]"
                                            class="w-100" style="text-decoration: none !important;"
                                            aria-label="Treatment">
                                            <img loading="lazy" src={{items.treatmentImage}} class="m-auto"
                                                alt="treatmentImage" style="width: 28px;height: 28px;">
                                            <p class="text-center treatmentTitle pt-0 pb-0 mb-1">
                                                {{items.treatmentTitle}}
                                            </p>
                                        </a>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </ng-template>
                    <ng-template carouselSlide>
                        <div class=" text-center mx-2 p-0" [ngClass]="{'clicked': clicked, '': !clicked}">
                            <a [routerLink]="['Smile Design']" aria-label="Treatment" class="w-100"
                                style="text-decoration: none !important;">
                                <img loading="lazy" src="{{videoCdnUrl}}images/smileDesign-white.svg" class="m-auto"
                                    alt="smileDesign-white" style="width: 28px;height: 28px;">
                                <p class="text-center treatmentTitle pt-0 pb-0 mb-1" style="color:white">Smile Design
                                </p>
                            </a>
                        </div>
                    </ng-template>
                </owl-carousel-o>
            </div>

        </div>

        <div class="carouselContainer" *ngIf="isGeneralTreatments">
            <div class="container no-wrap justify-content-center align-items-start pt-2 pb-2">
                <div class="item text-center" Style="border-right: 2px solid #929a3e">
                    <a [routerLink]="['Treatments']" aria-label="Treatment" class="w-100">
                        <img loading="lazy" class="m-auto" style="width: 28px;height: 28px;"
                            lazyLoad="{{videoCdnUrl}}images/dentist.svg">
                        <p class="text-center treatmentTitle pt-0 pb-0 mb-1">General Treatments</p>
                    </a>
                </div>
                <div class="item text-center" *ngFor="let items of GeneralTreatments;let i = index">
                    <a [routerLink]="['Treatment',{TreatmentType:'General',TreatmentID:items.id,Treatment:items.treatmentTitle}]"
                        class="w-100" aria-label="Treatment">
                        <img loading="lazy" src={{items.treatmentImage}} class="m-auto"
                            style="width: 28px;height: 28px;">
                        <p class="text-center treatmentTitle pt-0 pb-0 mb-1">{{items.treatmentTitle}}</p>
                    </a>
                </div>
            </div>
        </div>

        <div class="carouselContainer" *ngIf="isPreventativeTreatments">
            <div class="container no-wrap justify-content-center align-items-start pt-2 pb-2">
                <div class="item text-center" Style="border-right: 2px solid #929a3e">
                    <a [routerLink]="['Treatments']" aria-label="Treatment" class="w-100">
                        <img loading="lazy" class="m-auto" style="width: 28px;height: 28px;"
                            lazyLoad="{{videoCdnUrl}}images/tooth.svg">
                        <p class="text-center treatmentTitle pt-0 pb-0 mb-1">Preventative Treatments</p>
                    </a>
                </div>
                <div class="item text-center" *ngFor="let items of PreventativeDentistry;let i = index">
                    <a [routerLink]="['Treatment',{TreatmentType:'Preventative',TreatmentID:items.id,Treatment:items.treatmentTitle}]"
                        [(ngModel)]="items.treatmentSectionTitle" ngDefaultControl
                        (click)="scrollTo(items.treatmentSectionTitle)" class="w-100" aria-label="Treatment">
                        <img loading="lazy" src={{items.treatmentImage}} class="m-auto"
                            style="width: 28px;height: 28px;">
                        <p class="text-center treatmentTitle pt-0 pb-0 mb-1">{{items.treatmentTitle}}</p>
                    </a>
                </div>
            </div>
        </div>

        <div class="carouselContainer" *ngIf="isCosmeticTreatments">
            <div class="container no-wrap justify-content-center align-items-start pt-2 pb-2">
                <div class="item text-center" Style="border-right: 2px solid #929a3e">
                    <a [routerLink]="['Treatments']" class="w-100" aria-label="Treatment">
                        <img loading="lazy" src="{{videoCdnUrl}}images/teeth.svg" class="m-auto"
                            style="width: 28px;height: 28px;" lazyLoad="{{videoCdnUrl}}images/teeth.svg">
                        <p class="text-center treatmentTitle pt-0 pb-0 mb-1">Cosmetic Treatments</p>
                    </a>
                </div>
                <div class="item text-center" *ngFor="let items of CosmeticDentistry;let i = index">
                    <a class="w-100" aria-label="Treatment"
                        [routerLink]="['Treatment',{TreatmentType:'Cosmetic',TreatmentID:items.id,Treatment:items.treatmentTitle}]">
                        <img loading="lazy" src={{items.treatmentImage}} class="m-auto"
                            style="width: 28px;height: 28px;">
                        <p class="text-center treatmentTitle pt-0 pb-0 mb-1">{{items.treatmentTitle}}</p>
                    </a>
                </div>
            </div>
        </div>

        <div class="carouselContainer" *ngIf="isMissingTeethTreatments">
            <div class="container no-wrap justify-content-center align-items-start pt-2 pb-2">
                <div class="item text-center" Style="border-right: 2px solid #929a3e">
                    <a [routerLink]="['Treatments']" class="w-100" aria-label="Treatment">
                        <img loading="lazy" src="{{videoCdnUrl}}images/swollen.svg" class="m-auto"
                            style="width: 28px;height: 28px;" lazyLoad="{{videoCdnUrl}}images/swollen.svg">
                        <p class="text-center treatmentTitle pt-0 pb-0 mb-1">Missing Teeth Treatments</p>
                    </a>
                </div>
                <div class="item text-center" *ngFor="let items of MissingTeeth;let i = index">
                    <a class="w-100" aria-label="Treatment"
                        [routerLink]="['Treatment',{TreatmentType:'MissingTeeth',TreatmentID:items.id,Treatment:items.treatmentTitle}]">
                        <img loading="lazy" src={{items.treatmentImage}} class="m-auto"
                            style="width: 28px;height: 28px;">
                        <p class="text-center treatmentTitle pt-0 pb-0 mb-1">{{items.treatmentTitle}}</p>
                    </a>
                </div>
            </div>
        </div>

        <div class="carouselContainer" *ngIf="isBracesTreatments">
            <div class="container no-wrap justify-content-center align-items-start pt-2 pb-2">
                <div class=" item text-center" Style="border-right: 2px solid #929a3e">
                    <a [routerLink]="['Treatments']" class="w-100" aria-label="Treatment">
                        <img loading="lazy" src="{{videoCdnUrl}}images/dental.svg" class="m-auto"
                            style="width: 28px;height: 28px;" lazyLoad="{{videoCdnUrl}}images/dental.svg">
                        <p class="text-center treatmentTitle pt-0 pb-0 mb-1">Braces Treatments</p>
                    </a>
                </div>
                <div class="item text-center" *ngFor="let items of Braces;let i = index">
                    <a class="w-100" aria-label="Treatment"
                        [routerLink]="['Treatment',{TreatmentType:'Braces',TreatmentID:items.id,Treatment:items.treatmentTitle}]">
                        <img loading="lazy" src={{items.treatmentImage}} class="m-auto"
                            style="width: 28px;height: 28px;">
                        <p class="text-center treatmentTitle pt-0 pb-0 mb-1">{{items.treatmentTitle}}</p>
                    </a>
                </div>
            </div>
        </div>

        <div class="carouselContainer" *ngIf="isBoldBeautifulTreatments">
            <div class="container no-wrap justify-content-center align-items-start pt-2 pb-2">
                <div class="item text-center" Style="border-right: 2px solid #929a3e">
                    <a [routerLink]="['Treatments']" class="w-100" aria-label="Treatment">
                        <img loading="lazy" src="{{videoCdnUrl}}images/bold-beauty.svg" class="m-auto"
                            style="width: 28px;height: 28px;" lazyLoad="{{videoCdnUrl}}images/bold-beauty.svg">
                        <p class="text-center treatmentTitle pt-0 pb-0 mb-1">Bold & Beautiful</p>
                    </a>
                </div>
                <div class="item text-center" *ngFor="let items of BoldBeautiful;let i = index">
                    <a class="w-100" aria-label="Treatment"
                        [routerLink]="['Treatment',{TreatmentType:'BoldBeautiful',TreatmentID:items.id,Treatment:items.treatmentTitle}]">
                        <img loading="lazy" src={{items.treatmentImage}} class="m-auto"
                            style="width: 28px;height: 28px;">
                        <p class="text-center treatmentTitle pt-0 pb-0 mb-1">{{items.treatmentTitle}}</p>
                    </a>
                </div>
            </div>
        </div>

        <div class="carouselContainer" *ngIf="isConsicousTreatments">
            <div class="container no-wrap justify-content-center align-items-start pt-2 pb-2">
                <div class="item text-center" Style="border-right: 2px solid #929a3e">
                    <a [routerLink]="['Treatments']" class="w-100" aria-label="Treatment">
                        <img loading="lazy" src="{{videoCdnUrl}}images/teeth.svg" class="m-auto"
                            style="width: 28px;height: 28px;" lazyLoad="{{videoCdnUrl}}images/teeth.svg">
                        <p class="text-center treatmentTitle pt-0 pb-0 mb-1">ConsciousSedation</p>
                    </a>
                </div>
                <div class="item text-center" *ngFor="let items of ConsciousSedation;let i = index">
                    <a class="w-100" aria-label="Treatment"
                        [routerLink]="['Treatment',{TreatmentType:'ConsciousSedation',TreatmentID:items.id,Treatment:items.treatmentTitle}]">
                        <img loading="lazy" src={{items.treatmentImage}} class="m-auto"
                            style="width: 28px;height: 28px;">
                        <p class="text-center treatmentTitle pt-0 pb-0 mb-1">{{items.treatmentTitle}}</p>
                    </a>
                </div>
            </div>
        </div>

        <div class="carouselContainer" *ngIf="isAbout">
            <div class="container justify-content-center align-items-start pt-1 pb-1">
                <div class="text-center mx-2 my-0" *ngFor="let items of AboutCarousel;let i = index">
                    <a class="w-100" style="text-decoration: none !important;" aria-label="Treatment"
                        [routerLink]="['About Us',{Type:items.treatmentSectionTitle}]">
                        <img loading="lazy" src={{items.treatmentImage}} class="m-auto"
                            style="width: 28px;height: 28px;">
                        <p class="text-center treatmentTitle pt-0 pb-0 mb-1" style="color:white">
                            {{items.treatmentTitle}}</p>
                    </a>
                </div>
            </div>
        </div>

        <div class="carouselContainer" *ngIf="isReferal">
            <div class="container no-wrap justify-content-center align-items-start pt-1 pb-1">
                <div class="text-center mx-2 my-0" *ngFor="let items of ReferralCarousel;let i = index">
                    <div *ngIf="!isPatient && (isDentist || isPractice)">
                        <a class="w-100" style="text-decoration: none !important;" aria-label="Treatment"
                            *ngIf="items.treatmentTitle!=='Refer Yourself'" routerLink="{{items.treatmentTitle}}">
                            <img loading="lazy" src={{items.treatmentImage}} class="m-auto"
                                style="width: 28px;height: 28px;">
                            <p class="text-center treatmentTitle pt-0 pb-0 mb-1" style="color:white">
                                {{items.treatmentTitle}}</p>
                        </a>
                    </div>
                    <div *ngIf="!isDentist && !isPatient && !isPractice">
                        <a class="w-100" style="text-decoration: none !important;" routerLink="{{items.treatmentTitle}}"
                            aria-label="Treatment">
                            <img loading="lazy" src={{items.treatmentImage}} class="m-auto"
                                style="width: 28px;height: 28px;">
                            <p class="text-center treatmentTitle pt-0 pb-0 mb-1" style="color:white">
                                {{items.treatmentTitle}}</p>
                        </a>
                    </div>
                    <div *ngIf="isPatient && (!isDentist && !isPractice)">
                        <a class="w-100" style="text-decoration: none !important;" aria-label="Treatment"
                            *ngIf="items.treatmentTitle==='Refer Yourself'" routerLink="{{items.treatmentTitle}}">
                            <img loading="lazy" src={{items.treatmentImage}} class="m-auto"
                                style="width: 28px;height: 28px;">
                            <p class="text-center treatmentTitle pt-0 pb-0 mb-1" style="color:white">
                                {{items.treatmentTitle}}</p>
                        </a>
                    </div>
                </div>
            </div>
        </div>

        <div class="carouselContainer" *ngIf="isTechnology">
            <div class="container no-wrap justify-content-center align-items-start pt-1 pb-1">
                <div class="text-center mx-2 my-0" *ngFor="let items of TechnologyCarousel;let i = index">
                    <a class="w-100" style="text-decoration: none !important;" aria-label="Treatment"
                        [routerLink]="['Technology',{TechnologyType:items.treatmentSectionTitle}]">
                        <img loading="lazy" src={{items.treatmentImage}} class="m-auto"
                            style="width: 28px;height: 28px;">
                        <p class="text-center treatmentTitle pt-0 pb-0 mb-1" style="color:white">
                            {{items.treatmentTitle}}</p>
                    </a>
                </div>
            </div>
        </div>

        <div class="carouselContainer" *ngIf="isFaqs">
            <div class="container justify-content-center align-items-start pt-1 pb-1">
                <div class="text-center mx-2 my-0" *ngFor="let items of FAQCarousel;let i = index">
                    <a class="w-100" style="text-decoration: none !important;" aria-label="Treatment"
                        [routerLink]="['Faqs',{Type:items.treatmentSectionTitle}]">
                        <img loading="lazy" src={{items.treatmentImage}} class="m-auto"
                            style="width: 28px;height: 28px;">
                        <p class="text-center treatmentTitle pt-0 pb-0 mb-1" style="color:white">
                            {{items.treatmentTitle}}</p>
                    </a>
                </div>
            </div>
        </div>

        <div class="carouselContainer" *ngIf="isServices">
            <div class="container justify-content-center align-items-start pt-1 pb-1">
                <div class="text-center mx-2 my-0" *ngFor="let items of ServicesCarousel;let i = index">
                    <a class="w-100" style="text-decoration: none !important;"
                        [routerLink]="['services',{Type:items.treatmentSectionTitle}]">
                        <img src={{items.treatmentImage}} class="m-auto" style="width: 28px;height: 28px;">
                        <p class="text-center treatmentTitle pt-0 pb-0 mb-1" style="color:white">
                            {{items.treatmentTitle}}</p>
                    </a>
                </div>
            </div>
        </div>
    </div>
</nav>